import it from "./it.json";
import en from "./en.json";

const languages: Record<string, any> = {
    it,
    en,
};

export const getRequestedLanguages = (languageCode: string) => {
    return languages[languageCode] || languages.it;
};

export const getLanguage = (key: string, languageCode: string = "it") => {
    const selectedLanguage = getRequestedLanguages(languageCode);
    return selectedLanguage[key] || key;
};
